import { RG_TYPE } from "@project-rouge/rg-core";
import { ResizeRgObj } from "@project-rouge/rg-three";
function addPodium(building, props) {
  const levels = building.data.levels.slice().sort((a, b) => a.floorWorldBottom - b.floorWorldBottom);
  if (props.count >= levels.length) {
    throw new Error("Podium would remove all apartments, podium  not added.");
  }
  if (props.start + props.count > levels.length) {
    throw new Error("Podium would not be inside building levels range, podium not added.");
  }
  const podiumLevels = [];
  for (let i = props.start; i < props.start + props.count; i++) {
    podiumLevels.push(levels[i].levelIndex);
  }
  building.children = building.children.filter((c) => !(podiumLevels.includes(c.data.level) && c.type === RG_TYPE.Apartment));
  let cumulativeHeight = 0;
  for (let i = 0; i < levels.length; i++) {
    const level = levels[i];
    const isPodium = i >= props.start && i < props.start + props.count;
    for (let i2 = 0; i2 < building.children.length; i2++) {
      const child = building.children[i2];
      if (child.data.level !== level.levelIndex)
        continue;
      child.pos = [child.pos[0], cumulativeHeight, child.pos[2]];
      if (isPodium) {
        child.size = [child.size[0], props.height, child.size[2]];
        building.children[i2] = ResizeRgObj({ rgObj: child });
      }
    }
    if (isPodium) {
      level.floorWorldBottom = cumulativeHeight;
      level.isPodium = true;
      cumulativeHeight += props.height;
    } else {
      const next = levels[i + 1];
      const height = next ? next.floorWorldBottom - level.floorWorldBottom : 0;
      level.floorWorldBottom = cumulativeHeight;
      cumulativeHeight += height;
    }
  }
}
export {
  addPodium
};
//# sourceMappingURL=index41.js.map
